import Modal from '@/customComponents/uiComponents/modal/Modal.jsx'
import ModalHeader from '@/customComponents/uiComponents/modal/ModalHeader.jsx'
import IdentityCompletionFlow from '@/customComponents/uiComponents/global/IdentityCompletionFlow.jsx'

/**
 * "Complete your profile" IN A MODAL, on the page that discovered the gap.
 *
 * The booking gate (`422 identity_incomplete`) used to send the passenger to /settings, which
 * dropped them out of the confirm page they were on. The steps themselves — name, then a
 * VERIFIED email, then a verified phone — live in IdentityCompletionFlow.
 *
 * @param {string[]} missing     what the server still wants: 'name' | 'email' | 'phone'
 * @param {boolean}  isOpen
 * @param {Function} onClose
 * @param {Function} onCompleted called once every listed field is saved
 */
export default function CompleteProfileModal({missing, isOpen, onClose, onCompleted}) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} className="max-w-137.5!">
            <ModalHeader title="Complete your profile" onClose={onClose}/>
            {isOpen && (
                <IdentityCompletionFlow
                    missing={missing}
                    onCompleted={() => { onCompleted?.(); onClose?.() }}
                />
            )}
        </Modal>
    )
}
